import store from 'store';
import { mapHyphenSeparator } from '_legacy/services/hyphenSeparatorService';

export const getDisplayZone = (zone, fieldName) => {
    const storeMapping = store.getState()?.user?.zoneMapping;
    if (
        !storeMapping?.mappings ||
        storeMapping.datasetId !== store.getState()?.user?.group?.datasetId
    ) {
        return zone;
    }

    var found;

    switch (fieldName) {
        case 'loadZone':
        case 'loadZones':
        case 'loadlocationParts':
            found = storeMapping.mappings.find((item) => item.key === zone);
            break;
        case 'dischargeZone':
        case 'dischargeZones':
        case 'dischargelocationParts':
            const mappings =
                storeMapping.dischMappings ?? storeMapping.mappings;
            found = mappings.find((item) => item.key === zone);
            break;
        default:
            found = storeMapping.mappings.find((item) => item.key === zone);
    }

    return found ? found.value : zone;
};

export const formatDisplayZones = (zones, fallback, fieldName) => {
    // Only fall back to the singular field when the array field is null/undefined
    // (unmigrated data). An empty array [] means explicitly cleared — show blank.
    const effective = zones == null ? fallback : zones;
    if (!effective) return '';
    const arr = Array.isArray(effective) ? effective : [effective];
    if (arr.length === 0) return '';
    return arr
        .map((z) => getDisplayZone(z, fieldName))
        .join(` ${mapHyphenSeparator('/')} `);
};
